import React, { FC, useState, useEffect } from "react";
import { AnchorLink } from "gatsby-plugin-anchor-links";
import { PageLogo } from "../logo/astrid&gaston";

//styles
import "./index.scss";

export const Header: FC<HeaderProps> = ({ transition, callToAction }) => {
  const [menu, setMenu] = useState<boolean>(false);
  const [isScrolled, setIsScrolled] = useState<boolean>(false);

  useEffect(() => {
    if (menu) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [menu]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowWidth = window.innerWidth;
      if (scrollTop > 0 || windowWidth < 1280 || !transition) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    const handleResize = () => {
      const windowWidth = window.innerWidth;
      if (windowWidth < 1280 || !transition) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    handleScroll();
    handleResize();
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, [transition]);

  return (
    <header id="page-header">
      <div className={`header-element ${isScrolled ? "scrolled" : ""}`}>
        <div className="header-element__content">
          <PageLogo color={`${isScrolled ? "black" : "black"}`} />

          <div className="header-nav-container">
            <nav
              className={`header-nav ${menu ? "active-menu" : ""} ${
                isScrolled ? "scrolled" : ""
              }`}
            >
              <ul className="nav-list">
                <li onClick={() => (menu ? setMenu(false) : "")}>
                  <AnchorLink
                    title="Sección: Historia"
                    className="nav-link"
                    to="/#histo"
                  >
                    nuestra historia
                  </AnchorLink>
                </li>
                <li onClick={() => (menu ? setMenu(false) : "")}>
                  <AnchorLink
                    title="Sección: Horarios"
                    className="nav-link"
                    to="/#hours"
                  >
                    horarios
                  </AnchorLink>
                </li>
                <li onClick={() => (menu ? setMenu(false) : "")}>
                  <AnchorLink
                    title="Sección: Cartas"
                    className="nav-link"
                    to="/#menus"
                  >
                    cartas
                  </AnchorLink>
                </li>
                <li onClick={() => (menu ? setMenu(false) : "")}>
                  <AnchorLink
                    title="Sección: Eventos"
                    className="nav-link"
                    to="/#event"
                  >
                    eventos
                  </AnchorLink>
                </li>
                <li onClick={() => (menu ? setMenu(false) : "")}>
                  <AnchorLink
                    title="Sección: Tienda"
                    className="nav-link"
                    to="/#store"
                  >
                    tienda
                  </AnchorLink>
                </li>
                <li className="mobile-hidden">
                  <a
                    title="Redirección al sitio de reservas"
                    href={callToAction.booking.innerRedirection}
                    target="__blank"
                    className="button-container booking-link"
                  >
                    <button type="button" className="style-1">
                      {callToAction.booking.innerText}
                    </button>
                  </a>
                </li>
              </ul>

              <div className="webs-cta-container">
                <p className="webs-cta-container__presentation">
                  También puedes visitar:{" "}
                </p>
                <ul className="webs-cta-container__elements">
                  {/* //todo: title must be added to this redirection */}
                  {callToAction.webs.map((web, index) => (
                    <li className="element" key={index}>
                      <img
                        className="element__image"
                        src={web.webImage.node.publicUrl}
                        alt={web.webImage.node.altText}
                        title={web.webImage.node.title}
                      />
                      <a
                        className="element__redirection redirection-button"
                        target="__blank"
                        href={web.webUrl}
                      />
                    </li>
                  ))}
                </ul>
              </div>
            </nav>
            <div
              className="toggle-element"
              onClick={() => setMenu(!menu)}
            ></div>
          </div>
        </div>
      </div>
    </header>
  );
};
